import { NavMenu as BriqCommonNavMenu } from '@briq/shared'

export type DropDownLink = BriqCommonNavMenu.DropDownLink

export type NavigationLink = BriqCommonNavMenu.NavigationLink

export type NavMenuProps = BriqCommonNavMenu.NavMenuProps

export const NavMenu = BriqCommonNavMenu.NavMenu
